import { useEffect, useState } from 'react'

/** The current time, re-rendered every `intervalMs`. Keeps Date.now() out of render. */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
